import React from "react";
import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import useInput from "../../../hooks/useInput";
import usePostInspectionType from "../../../hooks/usePostInspectionType";
import { Button } from "react-bulma-components";
import Collapsible from "react-collapsible";

function InspectionType() {
  let [inspectionType, nameInput] = useInput({
    type: "text",
    label: "Inspection Name"
  });
  let [reminderDays, reminderInput] = useInput({
    type: "number",
    label: "Reminder (days in advance)"
  });
  let [warningDays, warningDaysInput] = useInput({
    type: "number",
    label: "Warning (days in advance)"
  });

  reminderDays = parseFloat(reminderDays);

  const [, postInspectionType] = usePostInspectionType({
    inspection_type: inspectionType,
    reminder_days: reminderDays,
    warning_days: warningDays
  });

  const handleSubmit = () => {
    postInspectionType();
  };

  return (
    <Box className="settings_type">
      <Collapsible
        className="title"
        triggerOpenedClassName="title"
        trigger="Add Inspection Type"
      >
        <Columns>
          {nameInput}
          {reminderInput}
          {warningDaysInput}
        </Columns>
        <Columns>
          <Columns.Column>
            <Button onClick={handleSubmit} fullwidth color={"success"}>
              Add
            </Button>
          </Columns.Column>
        </Columns>
      </Collapsible>
    </Box>
  );
}

export default InspectionType;
